export class StringModel {
    value: string = "";
}